const WHITESPACE_CHARACTER_REGEX = /\s/u;

export const isHighlightSearchWhitespace = (value: string): boolean => WHITESPACE_CHARACTER_REGEX.test(value);

export const normalizeHighlightSearchText = (value: string): string => {
  let normalized = '';
  let previousWasWhitespace = false;

  for (let index = 0; index < value.length; ) {
    const char = String.fromCodePoint(value.codePointAt(index) ?? 0);
    index += char.length;

    if (isHighlightSearchWhitespace(char)) {
      if (normalized && !previousWasWhitespace) {
        normalized += ' ';
        previousWasWhitespace = true;
      }
      continue;
    }

    normalized += char.normalize('NFC').toLowerCase();
    previousWasWhitespace = false;
  }

  return normalized.trimEnd();
};
